import React, {useEffect, useImperativeHandle, useRef, useState} from "react";
import {useDispatch} from "react-redux";

import {useAppSelector} from "redux/hooks";
import {inventoryMedicineStoreService} from "api";
import {
  Row,
  Spin,
  message,
  Form,
  Button,
  Space,
  Typography,
  Divider,
  Popconfirm,
} from "antd";
import {InputFields} from "components/common";
import {columns as columnsInit, inputFields as inputFieldsInit} from "./config";
import Icons from "assets/icons";
import TableInputAdd from "./TableInputAdd/TableInputAdd";

import {LOAI_FORM, TT_PHIEU_KHO, tabKeys} from "types/enums";
import {
  setDetailPhieu,
  setIdPhieu,
  setStatusPhieu,
  setTypeForm,
} from "redux/reducer/inventoryMedicine";
import Notification from "components/common/notification/notification";
import {convertIosStringToDate, formatDateToString} from "helper/common";
import {setActiveKey} from "redux/reducer/common";
import ModalCustom from "components/common/ModalCustom/ModalCustom";
import ModalDeny from "./ModalDeny/ModalDeny";
import moment from "moment";
import ModalPrint from "./ModalPrint/ModalPrint";

const InventoryDetail = React.forwardRef((props, ref) => {
  const dispatch = useDispatch();

  const activeTab = useAppSelector(state => state.common.activeTab);
  const [khoId, setKhoId] = useState(1);
  const typeForm = useAppSelector(state => state.inventory.typeForm);
  const statusPhieu = useAppSelector(state => state.inventory.statusPhieu);
  const idPhieu = useAppSelector(state => state.inventory.idPhieu);
  const detailPhieu = useAppSelector(state => state.inventory.detailPhieu);
  const khoKiemKeId = useAppSelector(state => state.inventory.khoKiemKeId);
  const listStore = useAppSelector(state => state.pharmacyStore.listStore);
  const [loading, setLoading] = useState(false);
  const [inputFields, setInputFields] = useState(inputFieldsInit);
  const [form] = Form.useForm();
  const [columns, setColumns] = useState(columnsInit);
  const [data, setData] = useState<any[]>([]);
  const [dataDeny, setDataDeny] = useState<any>();
  const [isShowModalPrint, setIsShowModalPrint] = useState(false);
  const modalRef = useRef<any>();
  useEffect(() => {
    setOptionsStore();
    // setOnChangeStore();
  }, [listStore]);
  useEffect(() => {
    if (activeTab == tabKeys.PHARMACY_STORE.INVENTORY_DETAIL) {
      if (khoKiemKeId && typeForm == LOAI_FORM.TAO_MOI) {
        form.setFieldValue("khoId", khoKiemKeId);
      }
    }
  }, [activeTab]);
  useEffect(() => {
    setTongTien();
  }, [data]);
  useEffect(() => {
    if (typeForm == LOAI_FORM.TAO_MOI) {
      dispatch(setStatusPhieu(TT_PHIEU_KHO.NHAP));
      form.resetFields();
      form.setFieldValue("createBy", localStorage.getItem("fullName"));
      form.setFieldValue("khoId", khoKiemKeId);
      form.setFieldValue("createDate", moment());
      getStoreData(khoKiemKeId);
    }
  }, [typeForm, khoKiemKeId]);
  useEffect(() => {
    setData([]);
    if (idPhieu != null && typeForm == LOAI_FORM.DA_TAO) {
      getDetailPhieu(idPhieu);
    }
  }, [idPhieu, typeForm]);
  useEffect(() => {
    if (detailPhieu) {
      form.setFieldsValue({
        ...detailPhieu,
        createDate: convertIosStringToDate(detailPhieu?.createDate),
      });
      dispatch(setStatusPhieu(detailPhieu?.tinhTrang));
      setData([...detailPhieu?.chiTietKiemKeDtos]);
    }
  }, [detailPhieu]);
  const setOptionsStore = () => {
    const options = listStore.map(e => ({value: e.id, label: e.name}));
    inputFields.find(e => e.name == "khoId").options = options;
    setInputFields([...inputFields]);
  };
  // const setOnChangeStore = () => {
  //   inputFields.find(e => e.name == "khoNhapId").onChange = e => {
  //     dispatch(setKhoNhapId(e));
  //   };
  //   inputFields.find(e => e.name == "khoXuatId").onChange = e => {
  //     dispatch(setKhoXuatId(e));
  //   };
  //   setInputFields([...inputFields]);
  // };
  const setTongTien = () => {
    let tongGiaTri = 0;
    data.forEach(e => {
      tongGiaTri += Number(e?.giaTriHang | 0);
    });

    form.setFieldValue("tongGiaTri", tongGiaTri);
  };
  const getStoreData = async khoId => {
    try {
      const res = await inventoryMedicineStoreService.getStoreData(khoId);
      setData([...res]);
    } catch (error) {}
  };
  const getDetailPhieu = async id => {
    try {
      setLoading(true);
      const res = await inventoryMedicineStoreService.getDetailInventory(id);
      setLoading(false);
      dispatch(setDetailPhieu(res));
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã có lỗi khi lấy thông tin phiếu");
    }
  };
  const getValuePhieu = async () => {
    await form.validateFields();
    const formValue = form.getFieldsValue();
    const chiTietKiemKeDtos = data.map(e => ({
      ...e,
      ngayNhap: formatDateToString(e.ngayNhap, null),
      ngayHetHan: formatDateToString(e.ngayHetHan, null),
      ngaySanXuat: formatDateToString(e.ngaySanXuat, null),
    }));
    if (chiTietKiemKeDtos.length == 0) {
      Notification("error", "Chưa chọn thuốc trong bảng");
      return false;
    } else {
      return {
        ...formValue,
        chiTietKiemKeDtos: chiTietKiemKeDtos,
      };
    }
  };
  const navigateToTabList = () => {
    dispatch(setActiveKey(tabKeys.PHARMACY_STORE.INVENTORY));
    reset();
  };
  const titleConfirm = () => {
    if (
      typeForm == LOAI_FORM.TAO_MOI ||
      (typeForm == LOAI_FORM.DA_TAO && statusPhieu == TT_PHIEU_KHO.NHAP)
    ) {
      return "Đồng ý hủy phiếu";
    }
    if (typeForm == LOAI_FORM.DA_TAO && statusPhieu == TT_PHIEU_KHO.CHO_DUYET) {
      return "Từ chối duyệt phiếu";
    } else {
      return "";
    }
  };
  const handleDeny = async description => {
    const valuePhieu = await getValuePhieu();
    const data = {
      ...valuePhieu,
      tinhTrang: TT_PHIEU_KHO.HUY_PHIEU,
      description: description,
    };
    try {
      await inventoryMedicineStoreService.updatePhieu(data);
      modalRef.current?.closeModal();
      Notification("success", `Đã từ chối phiếu kiểm kê mã ${data?.id}`);
      navigateToTabList();
    } catch (error) {
      Notification("error", `Đã có lỗi khi từ chối thông tin phiếu`);
    }
  };
  const reset = () => {
    dispatch(setIdPhieu(null));
    dispatch(setDetailPhieu(null));
    dispatch(setStatusPhieu(null));
    dispatch(setTypeForm(null));
    // setData([]);
  };

  const validateListMedicine = () => {
    let isValid = true;
    const listKey = {
      ["soLuongChenhLech"]: "số lượng chênh lệch",
      ["soLuongThuc"]: "số lượng tồn thực",
    };
    data.forEach((e, index) => {
      let listInvalidKey = [];
      Object.keys(listKey).map(key => {
        if (e[key] == null) {
          listInvalidKey.push(listKey[key]);

          isValid = false;
        }
      });
      if (listInvalidKey.length > 0) {
        let textListInvalidKey = "";
        listInvalidKey.forEach((e, ind) => {
          if (ind == listInvalidKey.length - 1 && ind > 0) {
            textListInvalidKey += ` và ${e} `;
          } else {
            textListInvalidKey += ` ${e}, `;
          }
        });
        message.warning(
          `Thiếu thông tin ${textListInvalidKey} ở bản ghi thứ ${index + 1}`,
          4
        );
      }
    });
    return isValid;
  };
  const cancel = async () => {
    if (statusPhieu == TT_PHIEU_KHO.NHAP) {
      const valuePhieu = await getValuePhieu();
      const data = {...valuePhieu, tinhTrang: TT_PHIEU_KHO.HUY_PHIEU};

      try {
        await inventoryMedicineStoreService.updatePhieu(data);
        reset();
        Notification("success", `Đã hủy phiếu kiểm kê mã ${data?.id}`);
        navigateToTabList();
      } catch (error) {
        Notification("error", `Đã có lỗi khi hủy thông tin phiếu`);
      }
    }
    if (statusPhieu == TT_PHIEU_KHO.CHO_DUYET) {
      // const valuePhieu = getValuePhieu();
      // const data = {...valuePhieu, tinhTrang: TT_PHIEU_KHO.TU_CHOI};
      modalRef.current?.openModal();
      // setDataDeny(data);
    }
  };
  const save = async () => {
    if (typeForm == LOAI_FORM.TAO_MOI) {
      var valuePhieu = await getValuePhieu();
      const data = {...valuePhieu, tinhTrang: TT_PHIEU_KHO.NHAP};

      if (data) {
        try {
          await inventoryMedicineStoreService.postPhieu(data);
          Notification("success", `Đã tạo phiếu thành công`);
          //  reset();
          navigateToTabList();
        } catch (error) {
          Notification("error", `Đã có lỗi khi tạo phiếu`);
        }
      }
    }
    if (typeForm == LOAI_FORM.DA_TAO) {
      var valuePhieu = await getValuePhieu();
      const data = {...valuePhieu, tinhTrang: statusPhieu};
      if (data) {
        try {
          const res = await inventoryMedicineStoreService.updatePhieu(data);
          Notification("success", `Đã lưu thông tin phiếu`); // reset();
          // navigateToTabList();
        } catch (error) {
          Notification("error", `Đã có lỗi khi lưu thông tin phiếu `);
        }
      }
    }
  };
  const send = async () => {
    if (statusPhieu == TT_PHIEU_KHO.NHAP) {
      var valuePhieu = await getValuePhieu();
      const data = {...valuePhieu, tinhTrang: TT_PHIEU_KHO.CHO_DUYET};
      if (data) {
        try {
          if (typeForm == LOAI_FORM.DA_TAO) {
            const res = await inventoryMedicineStoreService.updatePhieu(data);
            navigateToTabList();
          }
          if (typeForm == LOAI_FORM.TAO_MOI) {
            const res = await inventoryMedicineStoreService.postPhieu(data);

            navigateToTabList();
          }
          Notification("success", `Đã gửi thông tin phiếu`);
        } catch (error) {}
      }
    } else {
      let textStatusPhieu = "";
      if (statusPhieu == TT_PHIEU_KHO.CHO_DUYET) {
        textStatusPhieu = "chờ duyệt";
      }
      if (statusPhieu == TT_PHIEU_KHO.HUY_PHIEU) {
        textStatusPhieu = "hủy";
      }
      if (statusPhieu == TT_PHIEU_KHO.TU_CHOI) {
        textStatusPhieu = "từ chối";
      }
      if (statusPhieu == TT_PHIEU_KHO.HOAN_THANH) {
        textStatusPhieu = "hoàn thành";
      }
      Notification(
        "warning",
        `Không thể gửi duyệt phiếu ở trạng thái ${textStatusPhieu}`
      );
    }
  };
  const complete = async () => {
    if (statusPhieu == TT_PHIEU_KHO.CHO_DUYET) {
      var valuePhieu = await getValuePhieu();
      const data = {...valuePhieu, tinhTrang: TT_PHIEU_KHO.HOAN_THANH};
      const isValid = validateListMedicine();

      if (data && isValid) {
        try {
          const res = await inventoryMedicineStoreService.updatePhieu(data);

          Notification(
            "success",
            `Đã chuyển phiếu thành trạng thái hoàn thành`
          );
          navigateToTabList();
        } catch (error) {}
      }
    } else {
      Notification("warning", "Chỉ hoàn thành khi ở trạng thái Chờ duyệt");
    }
  };

  const handleOnPrint = () => {
    // console.log('list id in dich vu', listId);
    setIsShowModalPrint(true);
  };

  const handleOpen = () => {
    setIsShowModalPrint(false);
  };

  const handleCancelPrint = () => {
    setIsShowModalPrint(false);
  };

  return (
    <Spin spinning={loading}>
      <div className="detail-patient-analysis">
        <div className="container">
          <Typography.Text strong>Thông tin phiếu kiểm kê</Typography.Text>
          <Divider type="horizontal" style={{margin: 0, marginBottom: 8}} />
          <div className="container-main">
            <Form form={form}>
              <Row gutter={[16, 8]}>
                {" "}
                {inputFields && <InputFields data={inputFields}></InputFields>}
              </Row>
              <Row justify={"end"} style={{marginTop: 8}}>
                <Space size={"small"}>
                  <Popconfirm
                    title={titleConfirm}
                    onConfirm={cancel}
                    okText="Đồng ý"
                    cancelText="Hủy"
                    disabled={
                      typeForm == LOAI_FORM.DA_TAO &&
                      (statusPhieu == TT_PHIEU_KHO.DA_DUYET ||
                        statusPhieu == TT_PHIEU_KHO.HOAN_THANH)
                    }
                  >
                    <Button
                      type="primary"
                      danger
                      icon={<Icons.close rev={0}></Icons.close>}
                      disabled={
                        typeForm == LOAI_FORM.DA_TAO &&
                        statusPhieu != TT_PHIEU_KHO.NHAP &&
                        statusPhieu != TT_PHIEU_KHO.CHO_DUYET
                      }
                    >
                      Hủy
                    </Button>
                  </Popconfirm>

                  <Button
                    type="primary"
                    icon={<Icons.save rev={0}></Icons.save>}
                    onClick={save}
                    disabled={
                      typeForm == LOAI_FORM.DA_TAO &&
                      statusPhieu != TT_PHIEU_KHO.NHAP &&
                      statusPhieu != TT_PHIEU_KHO.CHO_DUYET
                    }
                  >
                    Lưu lại
                  </Button>

                  {/* <Button
                type="primary"
                danger
                icon={<Icons.close rev={0}></Icons.close>}
              >
                Sao chép
              </Button> */}
                  <Button
                    type="ghost"
                    className="btn-sub"
                    icon={<Icons.upload rev={0}></Icons.upload>}
                    onClick={send}
                    disabled={
                      typeForm == LOAI_FORM.DA_TAO &&
                      statusPhieu != TT_PHIEU_KHO.NHAP
                    }
                  >
                    Gửi phiếu
                  </Button>
                  <Button
                    type="ghost"
                    className="btn-sub"
                    onClick={complete}
                    disabled={
                      typeForm == LOAI_FORM.DA_TAO &&
                      statusPhieu != TT_PHIEU_KHO.CHO_DUYET
                    }
                  >
                    Hoàn thành
                  </Button>
                </Space>
              </Row>
            </Form>
          </div>
        </div>
        <div className="container">
          <Row justify={"space-between"} style={{padding: "10px 0", alignItems: "center"}}>
            <Typography.Text strong>Bảng kiểm kê</Typography.Text>
            <Button
              icon={<Icons.file rev={0} />}
              className="btn-sub"
              type="ghost"
              onClick={handleOnPrint}
            >
              In bảng kiểm kê
            </Button>
          </Row>
          <Divider type="horizontal" style={{margin: 0, marginBottom: 8}} />
          <div className="container-main">
            {columns && data && (
              <TableInputAdd
                scroll={{x: 4800}}
                setData={setData}
                isCheckbox={undefined}
                isPagination={false}
                data={data}
                column={columns}
                disabled={undefined}
              ></TableInputAdd>
            )}
          </div>
        </div>
        <ModalCustom ref={modalRef} width={400} title={`Lý cho từ chối`}>
          <ModalDeny handleDeny={handleDeny}></ModalDeny>
        </ModalCustom>
        <ModalPrint
          isShowModal={isShowModalPrint}
          handleOk={handleOpen}
          handleCancel={handleCancelPrint}
          dataTable={data}
          storeName={form.getFieldValue("khoId")}>
        </ModalPrint>
      </div>
    </Spin>
  );
});

export default InventoryDetail;
